import { Component, Input } from '@angular/core';

@Component({
  selector: 'share-section-card',
  templateUrl: './share-section-card.component.html',
  styleUrls: ['./share-section-card.component.scss']
})
export class ShareSectionCardComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() badgeValue = '';
  @Input() badgeSeverity: 'success' | 'info' | 'warning' | 'danger' = 'info';
  @Input() shadow: 'shadow-1' | 'shadow-2' | 'shadow-3' = 'shadow-2';
  @Input() padding = 'p-4';
}
